export default __webpack_public_path__ + "static/media/group-option-glasses-unselected.98952de6.svg";